// src/App.js
import SkinSite from './skinsite-prototype';

function App() {
  return <SkinSite />;
}

export default App;